// Configurações da aplicação
export const config = {
  googleSheets: {
    spreadsheetId: '1r7M_sgnOhuJ40EgR86g8zH8_LQvY54z2zBaHd2wPVdA',
    worksheetName: 'list'
  },
  
  // URLs de exemplo para fallback
  fallbackImageUrl: 'https://via.placeholder.com/300x200?text=Imagem+não+encontrada',
  
  // Categorias disponíveis no sistema
  productCategories: [
    'motor',
    'suspensao', 
    'freios',
    'eletrica',
    'carroceria',
    'transmissao'
  ]
} as const;